

































































































































import {
  defineComponent, computed, PropType,
} from '@vue/composition-api'
import { FieldType } from '@/components/types/FormFields'

/**
 * General shape of a row,
 */
interface Row {
  label: string;
  type?: FieldType;
  value?: string;
  actionIcon?: string;
}

export interface RowData {
  [key: string]: Row;
}

export default defineComponent({
  props: {
    /**
     * Key/val object with the rows to display, with the shape
     * of Rows
     */
    rowData: {
      type: Object as PropType<RowData>,
      required: true,
    },
    /**
     * A string array with the names of the rows to hide,
     * (the names corresponding to the keys of ´rows´.
     */
    hideRows: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    /**
     * An optional message that can be displayed if a row
     * has no value, e.g. 'data no set'.
     */
    missingValueMessage: {
      type: String,
      required: false,
      default: 'data not available',
    },
  },

  setup(props, context) {
    const displaySize = computed(() => context.root.$vuetify.breakpoint)

    function onActionIconClicked(rowName: string) {
      context.emit('action-icon-clicked', rowName)
    }

    // Checks whether a value is missing (used in the template)
    const isMissingValue = (v: unknown) => v === undefined
      || v === ''
      || v === '<p></p>'
      || v === null

    function isHidden(rowName: string) {
      return props.hideRows.includes(rowName)
    }

    return {
      displaySize,
      onActionIconClicked,
      isMissingValue,
      isHidden,
    }
  },
})

